import {
  STORE as onboardingStepsStore,
  GET_CARD_REQUEST,
} from "@/store/modules/onboardingSteps/onboardingSteps.types";
import store from '@/store/index'

export default async function hasCardRequestInProccess({ next }) {

    await store.dispatch(`${onboardingStepsStore}/getProvisionalCards`);

    const cardRequest = store.getters[`${onboardingStepsStore}/${GET_CARD_REQUEST}`];

    if(cardRequest && cardRequest.status === 'IN_PROCCESS') {
      return next();
    }

    return next('/wallet');
}
